(function () {
  "use strict";

  var labelsByPath = {
    "/": "Inicio",
    "/collections/all": "Productos",
    "/pages/contact": "Contacto",
    "/search": "Buscar"
  };

  function translateNavigation() {
    document.querySelectorAll("header nav a, footer a").forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      var path = url.pathname.replace(/\/$/, "") || "/";
      var currentLabel = link.textContent.trim().toLowerCase();
      var defaultEnglishLabels = ["home", "catalog", "products", "contact", "search"];
      if (labelsByPath[path] && defaultEnglishLabels.includes(currentLabel)) {
        link.textContent = labelsByPath[path];
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", translateNavigation);
  else translateNavigation();
  document.addEventListener("shopify:section:load", translateNavigation);
})();
